import { List, ListItem, styled } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { getAgGridTableCellData } from 'core/utils';
import { PricingHelper } from 'pricing/helpers';

const PricingListItem = styled(ListItem)({
  justifyContent: 'flex-end',
});

interface IProps extends ICellRendererParams {
  columnId: string;
  pricingField: string;
  pricingItemsField?: string;
}

const PricingPerUomCell = ({ columnId, pricingField, pricingItemsField, ...props }: IProps) => {
  const data = getAgGridTableCellData(props, columnId);

  if (!data) {
    return props?.value;
  }

  let items = [];
  const { uom } = data;

  if (pricingItemsField) {
    items = data[pricingItemsField];
  } else {
    items = [
      {
        id: null,
        [pricingField]: data[pricingField],
      },
    ];
  }

  return (
    <List sx={{ justifyContent: 'center' }}>
      {items?.map((item) => (
        <PricingListItem key={item.id}>
          {PricingHelper.formatPricingPerUom(item[pricingField], uom)}
        </PricingListItem>
      ))}
    </List>
  );
};

export default PricingPerUomCell;
